import React from "react";
import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import { Tupel } from "components";
import { TVehicle } from "types";

import Zusatzleistungen from "./Zusatzleistungen";
import BankInfo from "./BankInfo";

interface IDetail {
  vehicle: TVehicle;
  financeRate?: any;
  short?: boolean;
}

const Credit: React.FC<IDetail> = ({
  financeRate,
  vehicle,
  short = false,
}): JSX.Element => {
  const {
    rate,
    downPayment,
    runtime,
    bank,
    borrowingRate,
    apr,
    total,
    netLoanAmount,
  } = financeRate;
  const { formatMessage: t } = useIntl();
  const { preis_fracht_vk_brutto = 0 } = vehicle;
  const has_fracht: boolean = !!(
    preis_fracht_vk_brutto && preis_fracht_vk_brutto > 0
  );
  const vatInformation =
    financeRate.customerType === "business"
      ? "netto zuzüglich MwSt., nur für Gewerbekunden"
      : "inkl. MwSt.";
  return (
    <Box>
      <Tupel
        labelId="page.detail.finance.detail.rate"
        label="Monatliche Rate"
        euro={rate}
        digits={2}
        boxProps={{ fontWeight: "bold" }}
        information={vatInformation}
        informationPosition="right"
      />

      <Zusatzleistungen financeRate={financeRate} />
      <Tupel
        labelId="common.type"
        textId={
          "filter.financial.v2.rateType.options." + financeRate.type + ".label"
        }
        text={
          financeRate.type === "balloonbusiness"
            ? "gewerbliche Finanzierung"
            : "Finanzierung"
        }
      />
      {has_fracht && (
        <Tupel
          label="Zuzüglich Überführungskosten (einmalig)"
          labelId="page.detail.finance.detail.rateWithTransport"
          euro={preis_fracht_vk_brutto}
          digits={2}
          boxProps={{ fontWeight: "bold" }}
        />
      )}
      <Tupel
        labelId="common.contractRuntime"
        number={runtime}
        unit={t({ id: "common.months" })}
      />
      <Tupel label="Fahrzeugpreis" euro={vehicle.preis} digits={2} />
      <Tupel
        labelId="filter.financial.downPayment.title.label"
        force
        euro={downPayment}
        digits={2}
      />
      {!short && (
        <>
          <Tupel
            labelId="filter.financial.borrowingRate.label"
            digits={2}
            percent={borrowingRate / 100}
          />
          <Tupel label="Effektiver Jahreszins" digits={2} percent={apr / 100} />
          <Tupel
            label="Nettodarlehnsbetrag"
            euro={netLoanAmount - downPayment}
            digits={2}
          />
          <Tupel label="Gesamtbetrag" euro={total} digits={2} />
          <BankInfo bank={bank} />
          {bank.legalTextFinanceFull?.length > 1 && (
            <Typography
              variant="body1"
              sx={{ px: 1, backgroundColor: "grey.50" }}
            >
              {bank.legalTextFinanceFull}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default Credit;
